import api from "@/apis/AuditAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("Audit", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AuditID",
      code: "AuditID",
      name: "Description",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  loadAssetAuditYetPaging: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "asset-audit-yet-paging"].join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    if (res) {
      return res;
    }
  },

  loadAssetAuditDoingPaging: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "asset-audit-doing-paging"].join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    if (res) {
      return res;
    }
  },

  loadAssetAuditDonePaging: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "asset-audit-done-paging"].join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    if (res) {
      return res;
    }
  },

  loadIncrementAssetAuditPaging: async function (context, payload) {
    let request = {
      url: [api.getAPIUrl(), "asset-audit-done-paging"].join("/"),
      data: payload,
    };
    let res = await httpClient.postAsync(request);
    if (res) {
      return res;
    }
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
